class LoadMoreProducts extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.load-more-products__button');
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  onClick = async () => {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl || this.loading) return;

    this.loading = true;
    this.button.disabled = true;
    this.button.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-testid="product-grid"]');
      const currentGrid = document.querySelector('[data-testid="product-grid"]');
      if (!newGrid || !currentGrid) throw new Error('Grid not found');

      const newItems = newGrid.querySelectorAll('.product-grid__item');
      newItems.forEach((item) => currentGrid.appendChild(item));

      const newLoadMore = doc.querySelector('load-more-products');
      const newNextUrl = newLoadMore?.dataset.nextUrl;
      if (newNextUrl) {
        this.dataset.nextUrl = newNextUrl;
        this.button.disabled = false;
        this.button.classList.remove('is-loading');
      } else {
        this.remove();
      }

      window.history.replaceState({}, '', nextUrl);
    } catch (err) {
      console.error('Load more failed:', err);
      this.button.disabled = false;
      this.button.classList.remove('is-loading');
    } finally {
      this.loading = false;
    }
  };
}

customElements.define('load-more-products', LoadMoreProducts);
